// extracted by mini-css-extract-plugin
export default {"heading":"Availability_heading__P7Tma","wrapper":"Availability_wrapper__RC7FE"};